import { Response } from '@/components/interactive/Quiz/common';
import theme from '@/constants/theme';
import { useId } from 'react';

interface Props {
  option: string;
  questionId: string;
  response: string[];
  onChangeResponse?: (response: Response['answer']) => void;
}

const CheckboxOption = ({ option, questionId, response, onChangeResponse }: Props) => {
  const checkboxId = useId();
  const isChecked = response?.includes(option) ?? false;

  const handleChangeResponse = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const newResponse = evt.target.checked
      ? [...(response ?? []), option]
      : response.filter((r) => r !== option);
    onChangeResponse?.(newResponse);
  };

  return (
    <label
      htmlFor={checkboxId}
      style={{
        display: 'flex',
        gap: 16,
        backgroundColor: isChecked ? theme.colors.background.secondary : 'inherit',
        color: isChecked ? theme.colors.primary : 'inherit',
        padding: 12,
        borderRadius: 8,
        cursor: 'pointer',
        border: `1px solid ${theme.colors.border}`,

        height: 'fit-content',
        alignItems: 'center',
      }}
    >
      <input
        id={checkboxId}
        type="checkbox"
        name={questionId}
        checked={isChecked}
        style={{ accentColor: theme.colors.primary, minWidth: 18, aspectRatio: 1 }}
        onChange={handleChangeResponse}
      />
      {option}
    </label>
  );
};

export default CheckboxOption;
